export const timediaUrl = "https://ws.timothee.fr/timedia";
export const youtubeUrl = "https://ws.timothee.fr/youtube";
export const mtUserUrl = "https://ws.timothee.fr/timedia";
// export const mtLrftUrl = "https://ws.timothee.fr/lrft";
// export const mtLrftUrl = "http://127.0.0.1:7010";
export const mtLrftUrl = "https://ws.timothee.fr/lrft";
// export const timediaUrl = "http://127.0.0.1:7100";
// export const mtUserUrl = "http://127.0.0.1:7005";
// export const timediaUrl =
// 	localStorage.getItem("timediaUrl") == null
// 		? "https://ws.timothee.fr/timedia"
// 		: localStorage.getItem("timediaUrl");

export const coloUrl =
	localStorage.getItem("coloUrl") == null
		? "https://ws.timothee.fr/colo"
		: localStorage.getItem("coloUrl");

export const timgestUrl =
	localStorage.getItem("timgestUrl") == null
		? "https://ws.timothee.fr/timgest-api"
		: localStorage.getItem("timgestUrl");

export const urlTimediaSearch = timediaUrl + "/public/medias";

//************************************************************************************************************************************************************* */
// STRIPE

// TAJ
export const cle_stripe_taj_publique =
	"pk_live_51GxtKoLVOUtYxwngPkSWfHmkXpkb9BCSgJPggB5Yg1EnwBQTHjWlHueMukroZZPSO71JfUzXT507QTiTzcQX4YRQ006DKa651M";
export const cle_stripe_taj_publique_TEST =
	"pk_test_51GxtKoLVOUtYxwngDSSH0ZrhvH5z1nr7oiHl11ub61giqaDOR7uLwm7TsIV6Aw8vP7Y1T42QEQp4n65opGfHI7s300TRR6oso3";

// NOLOT
export const cle_stripe_NOLOT_publique_TEST =
	"pk_test_on4y898bTfQKFPOOGeJKTXeu00qQoKTPjQ"; // test compte nolot

// MT
export const cle_stripe_mt_publique =
	"pk_live_51Gxv1lEEkSQFkSB7IPVLz1ewrHMANYEz1tG5hzKPsbEI6g1IBf2EDNcYretyayodEy7noUgbxFXyvImmc9i7Abtb00oboK6ApS";
export const cle_stripe_mt_publique_TEST =
	"pk_test_51Gxv1lEEkSQFkSB7Hk0KyOLl1lHOF0zuV3br0jA3RYPIFuQ1WD4C8yDqTvhPWZU5GgQ9mWm6iDN31AcEqvsOVoDp00oAjQRqTc";

// SOUTIEN
export const cle_stripe_soutien_publique = cle_stripe_taj_publique;

// ABONNEMENT
export const cle_stripe_abonnement_publique = cle_stripe_mt_publique;
// export const cle_stripe_abonnement_publique = cle_stripe_mt_publique_TEST;

//************************************************************************************************************************************************************* */
